import { Typography } from "@mui/material";
import React from "react";
import ReviewAuraMultipleChoice from "../components/organisms/ReviewAuraMultipleChoice";
import ReviewAuraQuestion from "../components/organisms/ReviewAuraQuestion";
import ReviewAuraUnitDateNumericChoice from "../components/organisms/ReviewAuraUnitDateNumericChoice";
import {
  getMappedQuestionRadioResponse,
  getMappedQuestionResponse,
  getMappedQuestionTextResponse,
  getMappedQuestionUnitizedResponse,
  getPreviousAnsweredValue,
} from "../utilities/auraHealthUtils";

function ReviewAuraComponentFactory({ componentType, nextAuraQuestion }) {
  switch (componentType) {
    case "SINGLE_CHOICE":
      const mappedSingleChoiceRes = getMappedQuestionResponse(nextAuraQuestion);
      return (
        <ReviewAuraQuestion
          mappedContent={mappedSingleChoiceRes}
          defaultValue={getPreviousAnsweredValue(nextAuraQuestion)}
          nextAuraQuestion={nextAuraQuestion}
        />
      );
    case "TEXT":
    case "NUMERIC":
    case "DATE":
    case "SEARCH":
    case "BLOOD_PRESSURE":
      const mappedComponentRes =
        getMappedQuestionTextResponse(nextAuraQuestion);
      return (
        <ReviewAuraQuestion
          mappedContent={mappedComponentRes}
          nextAuraQuestion={nextAuraQuestion}
        />
      );
    case "UNITIZED":
      const mappedUnitizedRes =
        getMappedQuestionUnitizedResponse(nextAuraQuestion);
      return (
        <ReviewAuraQuestion
          mappedContent={mappedUnitizedRes}
          nextAuraQuestion={nextAuraQuestion}
        />
      );
    case "MULTIPLE_CHOICE":
      const mappedCheckboxCompRes =
        getMappedQuestionRadioResponse(nextAuraQuestion);
      return (
        <ReviewAuraMultipleChoice
          nextAuraQuestion={nextAuraQuestion}
          mappedContent={mappedCheckboxCompRes}
          defaultValue={getPreviousAnsweredValue(nextAuraQuestion)}
          disableAllOptions={true}
        />
      );

    case "UNITIZED_CHOICE":
    case "DATE_CHOICE":
    case "NUMERIC_CHOICE":
      const mappedRadioCompRes =
        getMappedQuestionRadioResponse(nextAuraQuestion);
      return (
        <ReviewAuraUnitDateNumericChoice
          nextAuraQuestion={nextAuraQuestion}
          mappedContent={mappedRadioCompRes}
          defaultValue={getPreviousAnsweredValue(nextAuraQuestion)}
          disableAllOptions={true}
        />
      );
    default:
      return (
        <Typography variant="p3">
          {" "}
          Problem occurred while rendering the component - {componentType}
        </Typography>
      );
  }
}

export default ReviewAuraComponentFactory;
